import { render } from "./v-date-picker.vue?vue&type=template&id=61f4fdc6"
import script from "./v-date-picker.vue?vue&type=script&lang=js"
export * from "./v-date-picker.vue?vue&type=script&lang=js"

import "./v-date-picker.vue?vue&type=style&index=0&id=61f4fdc6&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__